import { render } from "./TheHeadersider.vue?vue&type=template&id=293ea130&scoped=true"
import script from "./TheHeadersider.vue?vue&type=script&lang=js"
export * from "./TheHeadersider.vue?vue&type=script&lang=js"

import "./TheHeadersider.vue?vue&type=style&index=0&id=293ea130&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/greenbelt_garbage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293ea130"]])

export default __exports__